import { useTranslations } from '@vocab/react';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate, useLocation } from 'react-router-dom';

import { useTypedSelector } from 'src/reducers';

import { useSetCandidateId } from '../hooks/useSetCandidateId';
import { useUserProfile } from '../hooks/useUserProfile';
import PageLoader from '../page-loader';
import { PageTitles } from '../pageTitle';
import { useRoutes } from '../routes';
import { useSetTrackingContext } from '../tracking/tealium';

import translations from './.vocab';
import UnsubscribeJobAlert from './jobalert';
import Unsubscribe from './unsubscribe';
import UnsubscribeCTP from './unsubscribe-ctp';

const UnsubscribeContainer = () => {
  const { authenticationStatus } = useUserProfile();

  useSetCandidateId();

  useSetTrackingContext();

  const [token, setToken] = useState<string>('');
  const [product, setProduct] = useState<string>('');
  const [isCTPUnsubscribe, setIsCTPUnsubscribe] = useState<boolean>(false);
  const [action, setAction] = useState<string | undefined>(undefined);

  const navigate = useNavigate();
  const { preferenceCentrePath } = useRoutes();
  const location = useLocation();
  const brand = useTypedSelector((store) => store.page.pageAnalytics.brand);
  const { t } = useTranslations(translations);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const paramToken = params.get('token');
    const paramProduct = params.get('product');
    const paramCTP = params.get('ctp');
    const paramAction = params.get('action');

    if (paramToken) {
      setToken(paramToken);
    } else {
      navigate(preferenceCentrePath);
    }

    setProduct(paramProduct || '');
    setIsCTPUnsubscribe(paramCTP === 'true');
    if (paramAction) {
      setAction(paramAction);
    }
  }, [navigate, location.search, preferenceCentrePath]);

  const getUnsubscribeContent = () => {
    if (product?.toLocaleLowerCase() === 'jobalert') {
      return (
        <UnsubscribeJobAlert
          token={token}
          authenticationStatus={authenticationStatus}
          action={action}
        />
      );
    }

    return isCTPUnsubscribe ? (
      <UnsubscribeCTP token={token} />
    ) : (
      <Unsubscribe token={token} />
    );
  };

  return (
    <>
      <Helmet>
        <title>{`${PageTitles[brand]} - ${t('unsubscribe-page-title')}`}</title>
      </Helmet>
      {token ? getUnsubscribeContent() : <PageLoader />}
    </>
  );
};

export default UnsubscribeContainer;
